export const CREATE_EMPLOYE = "CREATE_EMPLOYE";
export const RETRIEVE_EMPLOYES = "RETRIEVE_EMPLOYES";
export const UPDATE_EMPLOYE = "UPDATE_EMPLOYE";
export const DELETE_EMPLOYE = "DELETE_EMPLOYE";
export const DELETE_ALL_EMPLOYES = "DELETE_ALL_EMPLOYES";

